const initialState = {
  ayam_sate: [
    {
      data: null,
      step1: null,
      step2: null,
      step3: null,
      step4: null,
      scale_by: "",
    },
  ],
};

const receiveReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_DATA": {
      const newData = [...state[action.receiveType]];

      let index = newData.findIndex(
        (item) => item?.data?.value === action.payload.value,
      );

      if (index !== -1 || (newData.length === 1 && !newData[0].data)) {
        // Update existing item
        index = index === -1 ? 0 : index;
        newData[index] = {
          ...newData[index],
          data: action.payload,
        };
      } else {
        // Create new item
        newData.push({
          data: action.payload,
          step1: null,
          step2: null,
          step3: null,
          step4: null,
          scale_by: "",
        });
      }

      return {
        ...state,
        [action.receiveType]: newData,
      };
    }
    case "SET_SCALE_BY": {
      const newData = [...state[action.receiveType]];

      const index = newData.findIndex(
        (item) => item?.data?.value === action.payload.value,
      );

      newData[index] = {
        ...newData[index],
        scale_by: action.payload.scale_by,
      };

      return {
        ...state,
        [action.receiveType]: newData,
      };
    }
    case "SET_STEP_1": {
      const newData = [...state[action.receiveType]];

      const index = newData.findIndex(
        (item) => item?.data?.value === action.payload.value,
      );

      newData[index] = {
        ...newData[index],
        step1: action.payload,
      };

      return {
        ...state,
        [action.receiveType]: newData,
      };
    }
    case "SET_STEP_2": {
      const newData = [...state[action.receiveType]];

      const index = newData.findIndex(
        (item) => item?.data?.value === action.payload.value,
      );

      newData[index] = {
        ...newData[index],
        step2: action.payload,
      };

      return {
        ...state,
        [action.receiveType]: newData,
      };
    }
    case "SET_STEP_3": {
      const newData = [...state[action.receiveType]];

      const index = newData.findIndex(
        (item) => item?.data?.value === action.payload.value,
      );

      newData[index] = {
        ...newData[index],
        step3: action.payload,
      };

      return {
        ...state,
        [action.receiveType]: newData,
      };
    }
    case "SET_STEP_4": {
      const newData = [...state[action.receiveType]];

      const index = newData.findIndex(
        (item) => item?.data?.value === action.payload.value,
      );

      newData[index] = {
        ...newData[index],
        step4: action.payload,
      };

      return {
        ...state,
        [action.receiveType]: newData,
      };
    }
    case "EMPTY_STATE": {
      const newData = [...state[action.receiveType]];

      const index = newData.findIndex(
        (item) => item?.data?.value === action.payload.value,
      );

      if (newData.length === 1) {
        newData[index] = {
          data: null,
          step1: null,
          step2: null,
          step3: null,
          step4: null,
          scale_by: "",
        };
      } else {
        newData.splice(index, 1);
      }

      return {
        ...state,
        [action.receiveType]: newData,
      };
    }
    default:
      return state;
  }
};

export default receiveReducer;
